var map = {
	"./India.png": "c185",
	"./afh.png": "ac30",
	"./bd.png": "bec4",
	"./nbe.png": "0b2b",
	"./other.png": "3f57",
	"./pak.png": "9ed5",
	"./sllk.png": "5911",
	"./us.png": "e2bc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "162a";